import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 15_000, retry: (n, err) => !(err instanceof ApiError && err.status < 500) && n < 2 },
  },
});

/** Centavos → "R$ 1.234,56". */
export const money = (minor: number | null | undefined) =>
  minor == null ? '—' : (minor / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace(/\u00a0/g, ' ');
/** "2026-10-20" → "20/10/2026" */
export const date = (iso: string | null | undefined) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : '—');
export const dateTime = (iso: string) =>
  new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short', timeZone: 'America/Sao_Paulo' }).format(new Date(iso));

export const ROLE_LABEL: Record<string, string> = {
  cliente: 'Cliente',
  analista: 'Analista',
  admin: 'Admin',
  juridico: 'Jurídico',
};
